class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.buttonObserver = null;
    this.footerObserver = null;
    this.buttonHidden = false;
    this.footerVisible = false;
    this.initialized = false;
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    if (this.initialized) return;
    this.initialized = true;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
    } else {
      this.init();
    }

    document.addEventListener("variant:updated", this.handleVariantUpdate);
  }

  init() {
    const originalButton = document.querySelector('.pdp-atc button[type="submit"]');
    const footer = document.querySelector("#shopify-section-group-footer");

    if (!originalButton) return;

    this.buttonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.buttonHidden = !entry.isIntersecting;
          this.updateVisibility();
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 },
    );
    this.buttonObserver.observe(originalButton);

    if (footer) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        },
        { root: null, rootMargin: "0px", threshold: 0 },
      );
      this.footerObserver.observe(footer);
    }
  }

  updateVisibility() {
    this.classList.toggle("visible", this.buttonHidden && !this.footerVisible);
  }

  handleVariantUpdate(event) {
    const variant = event.detail?.variant;
    const button = this.querySelector('button[type="submit"]');
    if (!variant || !button) return;

    button.disabled = !variant.available;
    const textElement = button.querySelector(".atc-button__text");

    if (textElement) {
      textElement.textContent = variant.available
        ? button.dataset.addLabel || textElement.textContent
        : button.dataset.soldOutLabel || textElement.textContent;
    }
  }

  disconnectedCallback() {
    this.buttonObserver?.disconnect();
    this.footerObserver?.disconnect();
    document.removeEventListener("variant:updated", this.handleVariantUpdate);
    this.initialized = false;
  }
}

if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", StickyAddToCart);
}